import { render } from "./ArticleFull.vue?vue&type=template&id=449257ec&scoped=true"
import script from "./ArticleFull.vue?vue&type=script&lang=js"
export * from "./ArticleFull.vue?vue&type=script&lang=js"

import "./ArticleFull.vue?vue&type=style&index=0&id=449257ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-449257ec"]])

export default __exports__